module.exports = __webpack_public_path__ + "assets/img/btn-view-c1570e3d.png";